const seeMore = () => {
  const anchors = document.querySelectorAll('[see-more]')

  if (!anchors.length > 0) return

  anchors.forEach((anchor) => {
    anchor.addEventListener('click', (e) => {
      const header = document.querySelector('header')
      const fix = (header.classList.contains('--followme')) ? 75 : 145

      e.preventDefault()
      $('html, body').animate({
        scrollTop: e.currentTarget.closest('section').nextElementSibling.offsetTop - fix
      })
    })
  })
}
export default seeMore
